'use strict';

var React = require('react');

var SvgArrowDiagonalIcon = function SvgArrowDiagonalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.228 14.772c-.304-.304-.304-.797 0-1.101l7.113-7.114h-3.993c-.43 0-.779-.348-.779-.778 0-.43.349-.779.779-.779h5.873c.207 0 .405.082.55.228.147.146.229.344.229.55v5.874c0 .43-.349.779-.779.779-.43 0-.779-.35-.779-.78v-3.992l-7.113 7.113c-.304.304-.797.304-1.1 0Z"
  }));
};
SvgArrowDiagonalIcon.displayName = "ArrowDiagonalIcon";

exports.SvgArrowDiagonalIcon = SvgArrowDiagonalIcon;
